import { casinoStoreKey } from './casinoStoreConstants'

export const casinoStore = initialLocalStorageValues => ({
  [casinoStoreKey]: initialLocalStorageValues
})
